import React from "react";

export const STATUS_META = {
  submitted:    { label: "New",         color: "#94A3B8", bg: "#94A3B822" },
  shortlisted:  { label: "Shortlisted", color: "#06B6D4", bg: "#06B6D422" },
  interviewed:  { label: "Interviewed", color: "#F59E0B", bg: "#F59E0B22" },
  rejected:     { label: "Rejected",    color: "#EF4444", bg: "#EF444422" },
  hired:        { label: "Hired",       color: "#10B981", bg: "#10B98122" },
};

export const STATUS_ORDER = ["submitted", "shortlisted", "interviewed", "hired", "rejected"];

export const StatusBadge = ({ status, testId }) => {
  const meta = STATUS_META[status] || STATUS_META.submitted;
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium"
      style={{ color: meta.color, backgroundColor: meta.bg, border: `1px solid ${meta.color}33` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: meta.color }} />
      {meta.label}
    </span>
  );
};
